module.exports = __webpack_public_path__ + "img/not_found.5ba89ca9.svg";